import request from '@/utils/request'

// 激活码

let CodeUserApi = {

  /*列表*/
  getList(data, errorback) {
    return request._post('/shop/study.code_user/index', data, errorback);
  },

  /*删除*/
  del(data, errorback) {
    return request._post('/shop/study.code_user/del', data, errorback);
  },

  /*我的分类*/
  category(data, errorback) {
    return request._post('/shop/study.code_user/category', data, errorback);
  },

}

export default CodeUserApi;



// WEBPACK FOOTER //
// ./src/api/study/code_user.js